import { SubscriptionOptionEnum } from "@shared_packages/toolkit/types";

export type SubscriptionBillingTabOption = SubscriptionOptionEnum;

export const SUBSCRIPTION_BILLING_TABS: Array<{
  option: SubscriptionBillingTabOption;
  label: string;
}> = [
  { option: SubscriptionOptionEnum.PAYMENTS_ONLY, label: "Payments Only" },
  {
    option: SubscriptionOptionEnum.PAYMENTS_ONLY_EU,
    label: "EU Open Banking",
  },
  { option: SubscriptionOptionEnum.TOOLKIT, label: "Toolkit" },
  { option: SubscriptionOptionEnum.TOOLKIT_MOBILE, label: "Toolkit Mobile" },
  {
    option: SubscriptionOptionEnum.SHOPIFY_B2B_SUBSCRIPTION,
    label: "Shopify B2B",
  },
];

export function subscriptionTabLabel(option: string): string {
  return (
    SUBSCRIPTION_BILLING_TABS.find((t) => t.option === option)?.label ?? option
  );
}

const DELETED_STATUSES = new Set(["deleted", "deleted_in_process"]);

export function isDeletedSubscriptionStatus(status?: string | null): boolean {
  return DELETED_STATUSES.has((status ?? "").toLowerCase());
}

export type SubscriptionPillStatus =
  | "active"
  | "trialing"
  | "canceled"
  | "scheduled"
  | "preconfigured"
  | "empty";

export function resolveSubscriptionPillStatus(
  sub?: {
    status?: string | null;
    cancelAtPeriodEnd?: boolean | null;
  } | null
): SubscriptionPillStatus {
  if (!sub || isDeletedSubscriptionStatus(sub.status)) return "empty";
  const status = (sub.status ?? "").toLowerCase();
  if (status === "canceled" || status === "cancelled") return "canceled";
  if (sub.cancelAtPeriodEnd) return "scheduled";
  if (status === "incomplete") return "preconfigured";
  if (status === "trialing") return "trialing";
  if (status === "active") return "active";
  return "empty";
}

export const PILL_STATUS_LABEL: Record<SubscriptionPillStatus, string> = {
  active: "Active",
  trialing: "Trialing",
  canceled: "Canceled",
  scheduled: "Cancel scheduled",
  preconfigured: "Preconfigured",
  empty: "None",
};
